/* src/app/private/modules/organizations/organizations.component.scss */
/*# sourceMappingURL=organizations.component.css.map */
